import { useEffect, useState } from 'react'
import { ReactComponent as ClearIcon } from 'assets/images/icons/clear.svg'
import Select, { components } from 'react-select'
import { MemberOption } from 'modules/company/styles'
import Avatar from 'modules/auth/components/Avatar'
import { colors, UsersSelectable } from '../styles'
import { getCompany_storage } from 'utils/storageUtils'

const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <ClearIcon style={{ width: 16, height: 16, stroke: 'white' }} fill={colors['text-secondary']} />
    </components.MultiValueRemove>
  )
}
const MultiValueLabel = ({ children, ...props }) => {
  return (
    <components.MultiValueContainer {...props}>
      <MemberOption>
        <Avatar user={props.data} size={28} className='mr-2' />
        {props.data.name}
      </MemberOption>
    </components.MultiValueContainer>
  )
}
const remove_existing_members = (old_data, new_data) => {
  // member_code of existing_members (defaultValue)
  const existing_members = old_data.map((d) => d.value)
  return [
    ...old_data,
    ...new_data
      .filter((u) => u.is_active && u.user_id && existing_members.indexOf(u.member_code) === -1)
      .map((u) => ({ ...u.user, user_id: u.user_id, name: u.user ? u.user.name : u.name, value: u.member_code, option_type: 'user' }))
  ]
}
function UserMultiSelect(props) {
  const { user, isCreatorRemovable, options: _options, hidden } = props
  const [options, set_options] = useState([])
  const [new_options, set_new_options] = useState([])
  const [company] = useState(getCompany_storage())

  // INIT
  useEffect(() => {
    set_options(remove_existing_members(_options, company.members))
    set_new_options(remove_existing_members(_options, company.members))
  }, [_options, company.members])

  // Make hidden
  useEffect(() => {
    if (hidden?.length) {
      const hidden_values = hidden.map((o) => o.value)
      const new_options = []
      for (const option of options) {
        if (hidden_values.indexOf(option.value) === -1) {
          new_options.push(option)
        }
      }
      set_new_options(new_options)
    }
  }, [hidden, options])

  return (
    <UsersSelectable>
      <Select
        isMulti
        key={Math.random()}
        isDisabled={props.isDisabled || false}
        isClearable={false}
        defaultValue={isCreatorRemovable ? props.defaultValue : props.defaultValue.map((u) => (u.user_id === user.id ? { ...u, isFixed: true } : u))}
        options={new_options}
        components={{ MultiValueLabel, MultiValueRemove }}
        styles={{
          option: (styles) => {
            return {
              ...styles,
              display: 'flex'
            }
          },
          valueContainer: (base) => ({
            ...base,
            paddingLeft: 0
          }),
          multiValueLabel: (base) => ({
            ...base,
            padding: 0,
            paddingLeft: 0,
            paddingRight: 5,
            marginRight: 5
          }),
          multiValue: (base) => ({
            ...base,
            background: colors['light-blue-100'],
            borderRadius: 24,
            display: 'flex',
            alignItems: 'center',
            marginRight: 10
          }),
          multiValueRemove: (base, state) => ({
            ...base,
            display: state.data.isFixed ? 'none' : 'flex',
            paddingLeft: 0,
            height: '100%',
            ':hover': {
              background: 'none'
            }
          })
        }}
        formatOptionLabel={(member, i) => (
          <MemberOption key={i} className='pr-3'>
            <Avatar user={member} size={28} className='mr-2' />
            {member.name}
          </MemberOption>
        )}
        classNamePrefix='category'
        backspaceRemovesValue={false}
        onChange={(obj, { action, removedValue }) => {
          switch (action) {
            case 'deselect-option':
            case 'remove-value':
            case 'pop-value':
              if (removedValue.isFixed) return
              break
            case 'clear':
              obj = options.filter((v) => v.isFixed)
              break
            default:
              break
          }
          props.onChange(obj || [])
        }}
        className={`usermultiselect ${props.className || ''}`}
      />
    </UsersSelectable>
  )
}

export default UserMultiSelect
